import { FetchResult, gql } from 'apollo-boost';
import { IAnswer } from '../../../models/answer';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query FlaggedAnswer($uid: String!) {
        response(uid: $uid) {
            uid,
            answer,
            flagStatus: flag_status,
            exerciseType: exercise_type,
            createdAt: created_at,

            user {
                uid,
                email,
            }

            skill {
                uid,
                name,
                description
            },

            flags {
              uid,
              type,
              status,
              createdAt: created_at,
              updatedAt: updated_at

              creator: user {
                uid,
                email,
                firstName: first_name,
                lastName: last_name,
              }
            }

            participant {
                character {
                    uid
                    name,
                },
                emotionEpisode: emotion_episode {
                    uid,
                    description,

                    scene {
                        uid,
                        description,
                        narrative {
                            uid
                            title,
                            mediaType: media_type,
                        },
                        episode {
                            uid,
                            name,
                            season,
                            numberInSeason: number_in_season
                        }

                    }

                },
            }
        }
    }
`;

export async function getFlaggedAnswer(uid: string): Promise<IAnswer> {
    const result: FetchResult<{ response: IAnswer }> = await graphqlClient.query({
        query: QUERY,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.response;
}


/*
            {
                }

            }




*/
